import { FC, ReactNode } from 'react';
import Box from '@o2/ui/Box';

export interface LayoutFooterBarProps {
  children: ReactNode;
  'data-elm'?: string;
}

const LayoutFooterBar: FC<LayoutFooterBarProps> = ({ children, 'data-elm': dataElm }) => {
  return <Box data-elm={dataElm}>{children}</Box>;
};

export default LayoutFooterBar;
